import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthFacade } from '../store/facade/auth.facade';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  status = [401, 403];

  constructor(private facade: AuthFacade, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpEvent<any>) => {
        if (error instanceof HttpErrorResponse && this.status.includes(error.status)) {
          this.facade.logout(this.router.url);
        }
        return throwError(error);
      })
    );
  }
}
